import { useEffect } from "react";
import { apiRequest } from "../services/apiClient";
import { subscribeAppResume } from "../services/appResumeService";

const LAST_ZONE_KEY = "familyPlanner:lastSyncedTimeZone";

function localZoneInfo() {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Istanbul";
    return { timeZone, offsetMinutes: -new Date().getTimezoneOffset() };
  } catch {
    return { timeZone: "Europe/Istanbul", offsetMinutes: 180 };
  }
}

function storedZone() {
  try { return localStorage.getItem(LAST_ZONE_KEY) || ""; }
  catch { return ""; }
}

function rememberZone(value) {
  try { localStorage.setItem(LAST_ZONE_KEY, value); }
  catch {}
}

// Polling kullanmaz. Oturum açıldığında bir kez, sonrasında yalnız gerçek app
// resume olayında ve timezone değişmişse backend'i günceller.
export function useUserTimezone(user) {
  useEffect(() => {
    if (!user?.uid && !user?.firebase_uid && !user?.id) return undefined;
    let cancelled = false;

    const sync = async (source, force = false) => {
      const info = localZoneInfo();
      if (!force && storedZone() === info.timeZone) return;
      try {
        await apiRequest("/auth/timezone", {
          method: "POST",
          body: JSON.stringify({ ...info, source }),
        });
        if (!cancelled) rememberZone(info.timeZone);
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.warn("[timezone] Saat dilimi senkronize edilemedi:", error?.message || error);
        }
      }
    };

    // Her yeni uygulama oturumunda tek idempotent çağrı; periyodik istek yoktur.
    sync("app_start", true);
    const unsubscribe = subscribeAppResume(() => sync("app_resume", false), { delayMs: 1100 });
    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, [user?.uid, user?.firebase_uid, user?.id]);
}

export function currentTimeZonePayload() {
  return localZoneInfo();
}
